import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const dateFormat = "YYYY-MM-DD";

const ChangeDate = ({
  onSubmit,
  show = false,
  handleClose,
  payDate,
  setPayDate,
}) => {
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Change Pay Date</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {/* <form method="post" className="needs-validation"> */}
        <div className="form-row">
          <div className="mb-3">
            <DatePicker
              name="payDate"
              placeholder="Select Pay Date"
              defaultValue={payDate ? dayjs(payDate, dateFormat) : dayjs()}
              format={dateFormat}
              className="form-control"
              onChange={(date) =>
                setPayDate(date ? dayjs(date).format(dateFormat) : "")
              }
              style={{ width: "100%" }}
              allowClear={false}
              getPopupContainer={(trigger) => trigger.parentNode}
              // showNow={false}
            />
          </div>
        </div>
        <div className="text-end mt-3">
          <button type="type" className="btn btn-primary" onClick={handleClose}>
            Close
          </button>
          &nbsp;
          <button
            type="type"
            className="btn btn-primary"
            onClick={() => {
              handleClose();
              onSubmit();
            }}
          >
            Update Date
          </button>
        </div>
        {/* </form> */}
      </Modal.Body>
    </Modal>
  );
};

ChangeDate.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  payDate: PropTypes.string.isRequired,
  setPayDate: PropTypes.func.isRequired,
};

export default ChangeDate;
